import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthPatientService } from '@core/services/auth-patient.service';
import { catchError, of } from 'rxjs';

export const canActivateAuthBasket: CanActivateFn = () => {
  
  const authService = inject(AuthPatientService);

  return authService.canActivate().pipe(
    catchError(() => {
      return of(true);
    })
  );
};
